// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1BEra","dragIcon":"SortableItem_dragIcon__A1ra2","disabled":"SortableItem_disabled__1jXLL"};